export default __webpack_public_path__ + "static/media/map_pin_dark.a3605975.svg";